import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import {
    createBrowserRouter,
    Outlet,
    RouterProvider,
    Navigate,
} from "react-router-dom";

import Martin from "./pages/Martin.jsx";
import Josh from "./pages/Josh.jsx";
import NotFound from "./pages/404.jsx";
import "./styles/index.scss";

const router = createBrowserRouter([
    {
        element: <Outlet />,
        errorElement: <NotFound />,
        children: [
            {
                path: "/",
                element: <Martin />,
            },
            {
                path: "/trevor",
                element: <Navigate to="/josh" />,
            },
            {
                path: "/josh",
                element: <Josh />,
            },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
